import type { SummaryDataField } from '../types';

const options = [
  { content: 'Loans amount', value: 'loansAmount' },
  { content: 'Sales amount', value: 'salesAmount' },
  { content: 'Number of loans', value: 'loansCount' },
];

export const summaryFieldOptions = options as unknown as {
  content: string;
  value: SummaryDataField;
}[];
